<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Template Sharing Settings</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <p class="blurb">These settings will determine if projects created from this template will be default private/public or hidden/unhidden.</p>
        </div>
        <div class="is-flex">
          <div class="hidden field">
            <toggle-switch v-model="isHidden"></toggle-switch>
            <label class="label hidden-label">Hidden</label>
          </div>
          <div class="public field">
            <toggle-switch v-model="isPrivate"></toggle-switch>
            <label class="label public-label">Private</label>
          </div>
        </div>
        <input ref="templateInput" class="templateInput field input" type="text" :value="templateShareUrl">
        <fade-message :message="copySuccess" :error="copyError" @clearMessage="copySuccess = ''" @clearError="copyError = ''"></fade-message>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
      </section>
      <div class="modal-card-foot is-flex">
        <div class="modal-buttons">
          <button class="button is-primary is-uppercase ml-3" @click="getTemplateUrl">Get Link</button>
          <button class="button is-primary is-uppercase ml-3" @click="close">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'
import FadeMessage from '@/components/Controls/FadeMessage'

export default {
  mixins: [componentState],
  props: ['project'],
  components: {
    ToggleSwitch,
    FadeMessage
  },
  data: function () {
    return {
      active: false,
      errorMessage: '',
      isPrivate: false,
      isHidden: false,
      hiddenorUnhidden: '',
      templateShareUrl: `${this.$webRoot}/start/template?projectID=${this.project.id}&startButton=true&draft=true`,
      copySuccess: '',
      copyError: ''
    }
  },
  watch: {
    active: function (active) {
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    },
    isPrivate: function () {
      if (this.isPrivate) {
        this.templateShareUrl = this.templateShareUrl + '&private=true'
      } else {
        this.templateShareUrl = this.templateShareUrl.replace('&private=true', '')
      }
    },
    isHidden: function () {
      if (this.isHidden) {
        this.templateShareUrl = this.templateShareUrl + '&hidden=true'
      } else {
        this.templateShareUrl = this.templateShareUrl.replace('&hidden=true', '')
      }
    }
  },
  methods: {
    cancel: function () {
      this.$emit('modalCancel')
      this.close()
    },
    close: function () {
      this.active = false
    },
    getTemplateUrl: function () {
      this.$refs.templateInput.select()
      document.execCommand('copy')
      this.copySuccess = 'Url copied to clipboard'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.modal-card {
  text-align: center;
  overflow: hidden;
  .title {
    border-bottom: 1px solid #DCDCDC;
    padding: 1.3rem 0;
    font-weight: normal;
    width: 100%;
  }
  .close-button {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1.25rem;
    top: 0.5rem;
    border: none;
  }
  .submit-questions {
    margin-top: 1rem;
  }
  .modal-card-body {
    height: 100%;
    padding: 2rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .select {
      width: 90%;
      select {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        height: 40px;
        font-size: 1rem;
      }
    }
  }
  .template-desc {
    font-size: .875rem;
    color: #373737;
    line-height: 19px;
    min-height: 38px;
    white-space: normal;
  }
  .modal-card-head {
    padding-left: 0;
    padding-right: 0;
  }
  .modal-card-foot {
    justify-content: center;
  }
  .delete {
    position: absolute;
    right: 2%;
  }
  label {
    display: inline;
    padding-left: 0.5rem;
  }
  .public {
    padding-left: 2.5rem;
  }
  .templateInput {
    margin-top: 1rem;
  }
  .blurb {
    margin-bottom: 2rem;
  font-weight: 300;
  font-size: 0.95rem;
  }
}
</style>
